module.exports = __webpack_public_path__ + "static/media/01.44fa51c8.jpg";